/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { Tabs, Tab, CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
  onSnapshot,
  doc,
  runTransaction,
  collection,
  writeBatch,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../firebase';
import Communication from './Communication';
import { User } from '../../types';
import LoginPage from '../Members/LoginPage';
import SubmittedForms from './SubmittedForms';
//import Members from './Members';
import ContactComponent from './Contacts';
import Announcements from './Announcements';
import Events from './Events';
import { sundaySchoolTeachers } from '../../utils';
import Bulletins from './Bulletins';
import AVRequests from './AVRequests';
import Polls from './Polls';
import Products from './Products';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const pages = [
  'events',
  'submitted-forms',
  'members',
  'bulletins',
  'av-requests',
  'polls',
  'products',
];

const Admin = () => {
  const { page } = useParams();
  const auth = getAuth();
  const [user] = useAuthState(auth);
  const [userData, setUserData] = useState<User>();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const value = page ? pages.indexOf(page) + 1 : 0;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // setValue(newValue);
    nav(`/admin/${newValue === 0 ? '' : pages[newValue - 1]}`);
  };

  function parseTimestamp(timestampStr: string): Date {
    const datePart = timestampStr.split(' ')[0];
    const dateComponents = datePart.split('/');
    const month = parseInt(dateComponents[1], 10);
    const day = parseInt(dateComponents[2], 10);
    const year = parseInt(dateComponents[0], 10);

    return new Date(year, month - 1, day, 0, 0, 0);
  }

  const deleteAllDocumentsWithField = async () => {
    try {
      setBusy(true);
      const q = query(
        collection(db, 'forms'),
        where('formId', '==', 'breastCancerSeminar2025')
      );
      const snapshot = await getDocs(q);
      const batch = writeBatch(db);

      snapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });

      await batch.commit();
    } catch (error) {
      console.error('Error deleting documents: ', error);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    // Read CSV file and convert to JSON array for bulk insert
    const readCsvAndBulkInsert = async () => {
      try {
        setBusy(true);

        // Fetch the CSV file
        const response = await fetch('/ddt.csv'); // Assuming the file is in the public folder
        const csvText = await response.text();
        // Parse CSV to JSON
        const lines = csvText.split('\n');
        const headers = lines[0].split(',').map((header) => header.trim());

        const jsonData = lines
          .slice(1)
          .filter((line) => line.trim() !== '') // Remove empty lines
          .map((line, index) => {
            const values = line.split(',').map((value) => value.trim());
            const obj: any = {};

            headers.forEach((header, headerIndex) => {
              obj[header.replace(/(^"|"$)/g, '')] = (
                values[headerIndex] || ''
              ).replace(/(^"|"$)/g, ''); // Remove surrounding quotes
            });

            return {
              ...obj,
              formId: 'breastCancerSeminar2025',
              date: parseTimestamp(obj['Timestamp']),
            };
          });

        // Option 1: Using Transaction (for reads and writes with conditions)
        // await runTransaction(db, async (transaction) => {
        //   jsonData.forEach((item) => {
        //     const docRef = doc(collection(db, 'ddt_data'));
        //     transaction.set(docRef, item);
        //   });
        // });

        //Option 2: Using Batch (more efficient for write-only operations)
        // const batch = writeBatch(db);
        // jsonData.forEach((item) => {
        //   const docRef = doc(collection(db, 'forms'));
        //   batch.set(docRef, {
        //     id: docRef.id,
        //     ...item,
        //   });
        // });
        // await batch.commit();

        //deleteAllDocumentsWithField();
        console.log('Bulk insert completed successfully');
      } catch (error) {
        console.error('Error during CSV read and bulk insert:', error);
      } finally {
        setBusy(false);
      }
    };

    // Only run if user is authenticated and is admin
    if (user?.uid && userData?.isAdmin) {
      // Uncomment the line below to execute the CSV read and bulk insert
      readCsvAndBulkInsert();
    }
  }, [user?.uid, userData?.isAdmin]);

  // useEffect(() => {
  //   // Bulk insert into firestore using transaction
  //   const data = [
  //     { id: 1, name: 'one' },
  //     { id: 2, name: 'two' },
  //     { id: 3, name: 'three' },
  //   ];
  //   const bulkInsertData = async () => {
  //     try {

  //       // Option 1: Using Transaction (for reads and writes with conditions)

  //       // Option 2: Using Batch (more efficient for write-only operations)
  //       const batch = writeBatch(db);
  //       data.forEach((item) => {
  //         const docRef = doc(collection(db, 'forms'));
  //         batch.set(docRef, {
  //           id: docRef.id,
  //           name: item.name,
  //           createdAt: new Date(),
  //           createdBy: user?.uid || 'system',
  //         });
  //       });
  //       await batch.commit();

  //       console.log('Bulk insert completed successfully');
  //     } catch (error) {
  //       console.error('Error during bulk insert:', error);
  //     } finally {
  //       setBusy(false);
  //     }
  //   };

  //   bulkInsertData();
  // }, [user?.uid]);

  useEffect(() => {
    if (user?.uid) {
      setBusy(true);
      const unsub = onSnapshot(doc(db, 'users', user.uid), (doc) => {
        if (doc.exists()) {
          const d = doc.data();
          if (d?.roles?.includes('admin')) {
            d.isAdmin = true;
          }
          setUserData(d as User);
          setBusy(false);
        }
      });
      return () => unsub();
    }
  }, [user]);

  if (busy) return <CircularProgress />;
  const isAdmin = userData?.isAdmin || userData?.roles?.includes('admin');
  if (!isAdmin || !userData)
    return (
      <LoginPage
        onUserSet={() => {
          /* No action needed */
        }}
      />
    );
  // if (sundaySchoolTeachers.includes(userData.email.toLowerCase())) {
  //   return <SubmittedForms user={userData} />;
  // }
  return (
    <Box component={'span'}>
      <div className="contactus-hero">Admin</div>
      <Box sx={{ width: '100%' }}>
        <Box className="no-print">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
            indicatorColor="secondary"
            scrollButtons="auto"
          >
            {/* <Tab label="Communication" {...a11yProps(0)} /> */}
            <Tab label="Announcements" {...a11yProps(0)} />
            <Tab label="Events" {...a11yProps(1)} />

            <Tab label="Submitted Forms" {...a11yProps(2)} />
            <Tab label="Members" {...a11yProps(3)} />
            <Tab label="Bulletins" {...a11yProps(4)} />
            <Tab label="AV Requests" {...a11yProps(5)} />
            <Tab label="Polls" {...a11yProps(6)} />
            <Tab label="Products" {...a11yProps(7)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Announcements user={userData} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Events user={userData} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <SubmittedForms user={userData} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ContactComponent />
          {/* <Members /> */}
        </TabPanel>

        <TabPanel value={value} index={4}>
          <Bulletins user={userData} />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <AVRequests user={userData} />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <Polls user={userData} />
        </TabPanel>
        <TabPanel value={value} index={7}>
          <Products user={userData} />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default Admin;
